import { toPng } from 'html-to-image'
import { Link } from 'react-router-dom'

export default function CardActions({ cardRef, isPaid }) {

  const capture = async () => {
    if (!cardRef?.current) return null
    try {
      await toPng(cardRef.current, { pixelRatio: 2 })
      const dataUrl = await toPng(cardRef.current, {
        pixelRatio: 2,
        backgroundColor: '#052e16',
        cacheBust: true,
      })
      return dataUrl
    } catch (err) {
      console.error('Capture failed:', err)
      return null
    }
  }

  const handleDownload = async () => {
    if (!isPaid) return
    const dataUrl = await capture()
    if (!dataUrl) return
    const link = document.createElement('a')
    link.download = 'membership-card.png'
    link.href = dataUrl
    link.click()
  }

  const handlePrint = async () => {
    if (!isPaid) return
    const dataUrl = await capture()
    if (!dataUrl) return
    const printWindow = window.open('', '_blank')
    printWindow.document.write(`
      <html>
        <head>
          <title>Membership Card</title>
          <style>
            body { margin: 0; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #000; }
            img { max-width: 400px; width: 100%; }
            @media print { body { background: white; } }
          </style>
        </head>
        <body>
          <img src="${dataUrl}" />
          <script>
            window.onload = function() { window.print(); window.close(); }
          </script>
        </body>
      </html>
    `)
    printWindow.document.close()
  }

  if (!isPaid) {
    return (
      <div className="mt-6 sm:mt-8 flex flex-col items-center gap-3 w-full max-w-xs">
        <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800/50 px-6 py-4 w-full text-center">
          <div className="text-yellow-600 dark:text-yellow-400 font-bold text-xs uppercase tracking-widest mb-1">
            Card Locked
          </div>
          <p className="text-yellow-700/70 dark:text-yellow-200/70 text-xs leading-relaxed">
            Pay your season subscription to download and print your official membership card.
          </p>
        </div>
        <Link
          to="/subscribe"
          className="w-full bg-green-600 hover:bg-green-700 text-white py-3 font-bold uppercase tracking-widest text-sm transition-colors text-center"
        >
          Activate Membership
        </Link>
      </div>
    )
  }

  return (
    <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-6 sm:mt-8 w-full max-w-xs sm:max-w-none sm:w-auto">
      <button
        onClick={handleDownload}
        className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 font-bold uppercase tracking-widest text-sm transition-colors w-full sm:w-auto"
      >
        Download Card
      </button>
      <button
        onClick={handlePrint}
        className="border border-gray-300 dark:border-white/20 hover:border-green-600 text-gray-500 dark:text-gray-400 hover:text-green-600 dark:hover:text-white px-8 py-3 font-bold uppercase tracking-widest text-sm transition-colors w-full sm:w-auto"
      >
        Print Card
      </button>
    </div>
  )
}